
$w.onReady(function () {
    setVrColorChangeInteraction();
});

const setVrColorChangeInteraction = () => {
    const colorDefinitions = {
        grey: { buttonId: 'greyButton', imageId: 'greyVr', strokeId: 'greyStroke' },
        blue: { buttonId: 'blueButton', imageId: 'blueVr', strokeId: 'blueStroke' },
        cyan: { buttonId: 'cyanButton', imageId: 'cyanVr', strokeId: 'cyanStroke' },
    };

    for (const color in colorDefinitions) {
        const { buttonId, imageId, strokeId } = colorDefinitions[color];
        $w(`#${buttonId}`).onClick(() => {
            $w('#greyStroke,#blueStroke,#cyanStroke').hide();
            $w('#greyVr,#blueVr,#cyanVr').hide();

            $w(`#${imageId}`).show();
            $w(`#${strokeId}`).show();
        });
    }
};